import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "app-card",
  standalone: true,
  imports: [],
  templateUrl: "./card.component.html",
  styleUrl: "./card.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() size: "small" | "medium" | "large" = "medium";
  @Input() background: "default" | "orange" | "grey" = "default";
  @Input() hasBorder = false;

  @HostBinding("class") get hostClass(): string {
    return `app-card ${this.size} ${this.background} ${this.hasBorder ? "has-border" : ""}`;
  }
}
